import { Link } from "react-router-dom"
import {shareOnSocialMedia} from '../functions/VerifyAddToCart'
import { Facebook, Twitter, Instagram } from 'lucide-react';



export const Terms = () => {
  return (
    <div className="mt-12 flex flex-col md:flex-row justify-between items-center border-t border-gray-200 pt-8">
                
   {/* Términos y redes sociales */}
   <div
          
          className="mt-12 flex flex-col md:flex-row justify-between items-center border-t border-gray-200 pt-8"
        >
          <div className="flex flex-wrap gap-4 mb-4 md:mb-0">
            <Link
              to="/terminos"
              className="text-gray-600 hover:text-primary transition-colors flex items-center gap-1"
            >
              <span className="hover:underline">Términos y condiciones</span>
            </Link>
            <Link
              to="/garantias"
              className="text-gray-600 hover:text-primary transition-colors flex items-center gap-1"
            >
              <span className="hover:underline">Política de garantías</span>
            </Link>
          </div>

          <div className="flex gap-4">
            {[
              { icon: Facebook, color: '#1877F2', socialMedia: 'facebook' },
              { icon: Twitter, color: '#1DA1F2', socialMedia: 'twitter' },
              { icon: Instagram, color: '#E4405F', socialMedia: 'instagram' },
            ].map((social, index) => (
              <a
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  shareOnSocialMedia(social.socialMedia);
                }}
                className="p-2 rounded-full bg-white shadow-sm hover:shadow-md transition-all"
                style={{ color: social.color }}
              >
                <social.icon className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>
    </div>
  )
}

